export default function Style(){
  return (
    <style>
      {`
        .BUS-head-title{
     font-family: 'Fjalla One';
     color: #000000;
     font-size: 24px;
     line-height: 34px;
}
       
        `}
    </style>
  );
}
